const horarios = [
    {
        dia: "SEG",
        aulas: [
            { horario: "06h", aula: "Jiu Jitsu", professor: "Roberto Wosiack" },
            { horario: "08h", aula: "Jiu Jitsu", professor: "Roberto Wosiack" },
            { horario: "12h", aula: "Jiu Jitsu Avançado", professor: "Roberto Wosiack" },
            { horario: "16h30", aula: "Jiu Jitsu", professor: "Leonardo Vianna" },
            { horario: "18h", aula: "NoGi", professor: "Roberto Wosiack" },
            { horario: "18h15", aula: "Jiu Jitsu Kids 3", professor: "Mateus Jesus" },
            { horario: "19h30", aula: "Jiu Jitsu Basics", professor: "Nilton Nunes" },
            {
                horario: "19h30",
                aula: "Jiu Jitsu Nova Geração",
                professor: "Roberto Wosiack"
            },
            { horario: "20h30", aula: "Jiu Jitsu", professor: "Leonardo Vianna" }
        ]
    },
    {
        dia: "TER",
        aulas: [
            { horario: "07h", aula: "NoGi", professor: "Roberto Wosiack" },
            { horario: "08h", aula: "Jiu Jitsu", professor: "Roberto Wosiack" },
            { horario: "10h", aula: "Jiu Jitsu Kids 1", professor: "Johnny Lemes" },
            { horario: "12h", aula: "Jiu Jitsu Avançado", professor: "Roberto Wosiack" },
            { horario: "16h30", aula: "Jiu Jitsu", professor: "Leonardo Vianna" },
            { horario: "18h15", aula: "Jiu Jitsu Kids 2", professor: "Byanka Marchelli" },
            { horario: "18h15", aula: "Defesa Pessoal", professor: "Roberto Wosiack" },
            { horario: "18h15", aula: "Jiu Jitsu Mini Kids", professor: "Kayã" },
            {
                horario: "19h30",
                aula: "Jiu Jitsu Feminino",
                professor: "Byanka Marchelli e Amanda Olochove"
            },
            { horario: "19h30", aula: "Judô", professor: "Fernando Melo" },
            { horario: "20h30", aula: "Jiu Jitsu", professor: "Leonardo Vianna" }
        ]
    },
    {
        dia: "QUA",
        aulas: [
            { horario: "06h", aula: "Jiu Jitsu", professor: "Roberto Wosiack" },
            { horario: "08h", aula: "Jiu Jitsu", professor: "Roberto Wosiack" },
            {
                horario: "12h",
                aula: "Treino Avançado Sparring",
                professor: "Roberto Wosiack"
            },
            { horario: "16h30", aula: "Jiu Jitsu", professor: "Leonardo Vianna" },
            { horario: "18h", aula: "NoGi", professor: "Gaspar Guatimozin" },
            { horario: "18h15", aula: "Jiu Jitsu Kids 3", professor: "Mateus Jesus" },
            { horario: "19h30", aula: "Jiu Jitsu Basics", professor: "Nilton Nunes" },
            {
                horario: "19h30",
                aula: "Jiu Jitsu Nova Geração",
                professor: "Roberto Wosiack"
            },
            { horario: "20h30", aula: "NoGi", professor: "Leonardo Vianna" }
        ]
    },
    {
        dia: "QUI",
        aulas: [
            { horario: "07h", aula: "NoGi", professor: "Roberto Wosiack" },
            { horario: "08h", aula: "Jiu Jitsu", professor: "Roberto Wosiack" },
            { horario: "10h", aula: "Jiu Jitsu Kids 1", professor: "Johnny Lemes" },
            { horario: "12h", aula: "Jiu Jitsu Avançado", professor: "Roberto Wosiack" },
            { horario: "16h30", aula: "Jiu Jitsu", professor: "Leonardo Vianna" },
            { horario: "18h15", aula: "Jiu Jitsu Kids 2", professor: "Byanka Marchelli" },
            { horario: "18h15", aula: "Defesa Pessoal", professor: "Roberto Wosiack" },
            { horario: "18h15", aula: "Jiu Jitsu Mini Kids", professor: "Kayã" },
            {
                horario: "19h30",
                aula: "Jiu Jitsu Feminino",
                professor: "Byanka Marchelli e Amanda Olochove"
            },
            { horario: "19h30", aula: "Judô", professor: "Fernando Melo" },
            { horario: "20h30", aula: "Jiu Jitsu", professor: "Leonardo Vianna" }
        ]
    },
    {
        dia: "SEX",
        aulas: [
            { horario: "06h", aula: "Jiu Jitsu", professor: "Roberto Wosiack" },
            { horario: "08h", aula: "Jiu Jitsu", professor: "Roberto Wosiack" },
            { horario: "12h", aula: "NoGi", professor: "Roberto Wosiack" },
            { horario: "16h30", aula: "Jiu Jitsu", professor: "Leonardo Vianna" },
            { horario: "18h", aula: "NoGi", professor: "Gaspar Guatimozin" },
            { horario: "19h30", aula: "Jiu Jitsu Basics", professor: "Nilton Nunes" },
            {
                horario: "19h30",
                aula: "Jiu Jitsu Nova Geração",
                professor: "Gaspar Guatimozin"
            },
            { horario: "20h30", aula: "Open Mat", professor: "Roberto Wosiack" }
        ]
    },
    {
        dia: "SAB",
        aulas: [
            { horario: "09h", aula: "Defesa Pessoal", professor: "Johnny Lemes" },
            {
                horario: "10h30",
                aula: "Jiu Jitsu Lab",
                professor: "Professor/Instrutor Convidado"
            }
        ]
    }
];

export default horarios;
